import React from 'react'
import { Box, SimpleGrid, Skeleton, Stack } from '@chakra-ui/react'

const SkeletonDetail = () => {
  const colorSkeleton = 'bgSkeleton'
  return (
    <SimpleGrid
      templateColumns={{
        sm: '1fr',
        md: '1fr',
        lg: '6fr 6fr',
        xl: '6fr 6fr'
      }}
      spacing={7}
    >
      <Box pt={2} w={'100%'}>
        <Stack>
          <Skeleton
            w={'100%'}
            h={'450px'}
            startColor={colorSkeleton}
            endColor={colorSkeleton}
          />
          <Skeleton
            w={'100%'}
            h={'20px'}
            startColor={colorSkeleton}
            endColor={colorSkeleton}
          />
        </Stack>
      </Box>
      <Box padding="6" boxShadow="sm" bg="white">
        <Stack>
          <Skeleton
            w={'100%'}
            h={'100px'}
            startColor={colorSkeleton}
            endColor={colorSkeleton}
          />
          <Skeleton
            w={'100%'}
            h={'100px'}
            startColor={colorSkeleton}
            endColor={colorSkeleton}
          />
          <Skeleton
            w={'100%'}
            h={'100px'}
            startColor={colorSkeleton}
            endColor={colorSkeleton}
          />
          <Skeleton
            w={'100%'}
            h={'100px'}
            startColor={colorSkeleton}
            endColor={colorSkeleton}
          />
        </Stack>
      </Box>
    </SimpleGrid>
  )
}

export default SkeletonDetail
